<template>
  <div>
    <SubHeader title="Financial Details" />
    <div v-if="company && companyFinancial">
      <b-alert show variant="info" v-if="companyFinancial.length == 0"><strong>No Financial Details</strong> have been added for this Company</b-alert>
      <div class="table-wrapper" v-if="companyFinancial.length > 0">
        <table >
          <tr>
            <td>P &amp; L Summary</td>
            <td class="year-header" v-for="(year) in companyFinancial" :key="year.id">
              {{months[year.month - 1]}} {{year.year}}
              <div v-if="year.isProjection">Projection</div>
            </td>
          </tr>
          <tr>
            <td>Turnover</td>
            <td v-for="(year) in companyFinancial" :key="year.id">{{year.turnoverAdjusted | toCurrency(year.currencyPrefix)}}</td>
          </tr>
          <tr>
            <td>Bank Deposits</td>
            <td v-for="(year) in companyFinancial" :key="year.id">{{year.bankDepositsAdjusted | toCurrency(year.currencyPrefix)}}</td>
          </tr>
          <tr>
            <td>Gross Profit*</td>
            <td v-for="(year) in companyFinancial" :key="year.id">{{year.grossProfitAdjusted | toCurrency(year.currencyPrefix)}}</td>
          </tr>
          <tr>
            <td>Gross Profit (%)</td>
            <td v-for="(year) in companyFinancial" :key="year.id">{{year.grossProfitPercent }}</td>
          </tr>
          <tr>
            <td>EBIT*</td>
            <td v-for="(year) in companyFinancial" :key="year.id">{{year.ebitAdjusted | toCurrency(year.currencyPrefix)}}</td>
          </tr>
          <tr>
            <td>Depreciation</td>
            <td v-for="(year) in companyFinancial" :key="year.id">{{year.depreciationAdjusted | toCurrency(year.currencyPrefix)}}</td>
          </tr>
          <tr>
            <td>Amortisation</td>
            <td v-for="(year) in companyFinancial" :key="year.id">{{year.amortisationAdjusted | toCurrency(year.currencyPrefix)}}</td>
          </tr>
          <tr>
            <td>EBITDA*</td>
            <td v-for="(year) in companyFinancial" :key="year.id">{{year.ebitdaAdjusted | toCurrency(year.currencyPrefix)}}</td>
          </tr>
          <!-- <tr>
            <td class="row-header">Adjusted/Sustainable EBITDA*</td>
            <td v-for="(year) in companyFinancial" :key="year.id">{{year.adjustedEbitda | toCurrency}}</td>
          </tr> -->
          <tr>
            <td>Shareholders Funds</td>
            <td v-for="(year) in companyFinancial" :key="year.id">{{year.shareholdersFundsAdjusted | toCurrency(year.currencyPrefix)}}</td>
          </tr>
          <tr>
            <td>Surplus Assets</td>
            <td v-for="(year) in companyFinancial" :key="year.id">{{year.surplusAssetsAdjusted | toCurrency(year.currencyPrefix)}}</td>
          </tr>
          <tr>
            <td>No. of Employees</td>
            <td v-for="(year) in companyFinancial" :key="year.id">{{year.numberOfEmployees}}</td>
          </tr>
          <tr>
            <td>Freehold Property Value</td>
            <td v-for="(year) in companyFinancial" :key="year.id">{{year.freeholdPropertyValueAdjusted | toCurrency(year.currencyPrefix)}}</td>
          </tr>
          <tr>
            <td>Current Liabilities</td>
            <td v-for="(year) in companyFinancial" :key="year.id">{{year.currentLiabilitiesAdjusted | toCurrency(year.currencyPrefix)}}</td>
          </tr>
          <tr>
            <td>Net Assets</td>
            <td v-for="(year) in companyFinancial" :key="year.id"> {{year.netAssetsAdjusted | toCurrency(year.currencyPrefix)}}</td>
          </tr>
          <tr>
            <td>Research & Development</td>
            <td v-for="(year) in companyFinancial" :key="year.id">{{year.researchAndDevelopmentAdjusted | toCurrency(year.currencyPrefix)}}</td>
          </tr>
          <tr>
            <td>Taxation</td>
            <td v-for="(year) in companyFinancial" :key="year.id">{{year.taxationAdjusted | toCurrency(year.currencyPrefix)}}</td>
          </tr>
          <tr>
            <td>Capital Expenditure Financial Invest</td>
            <td v-for="(year) in companyFinancial" :key="year.id">{{year.capitalExpenditureFinancInvestAdjusted | toCurrency(year.currencyPrefix)}}</td>
          </tr>
          <tr>
            <td></td>
            <td v-for="(year) in companyFinancial" :key="year.id">
              <b-button block
                size="sm"
                variant="warning"
                type="button"
                @click="editFinancial(year)"
                        :disabled="onTheMarket"
                ><font-awesome-icon icon="edit" />&nbsp;Edit
              </b-button>
              <b-button block
                size="sm"
                variant="danger"
                type="button"
                @click="deleteFinancial(year.id)"
                        :disabled="onTheMarket"
                ><font-awesome-icon icon="times" />&nbsp;Delete
              </b-button>
            </td>
          </tr>
        </table>
      </div>

      <b-button class="add-finance"
        variant="primary"
        type="button"
        @click="addFinance()"
                :disabled="onTheMarket"
        ><font-awesome-icon icon="plus" />&nbsp;Add Financial Details
      </b-button>

      <b-row class="my-1">
        <b-col md="3">
          <label for="financialNotes">Financial Notes</label>
        </b-col>
        <b-col md="6">
          <b-form-textarea id="financialNotes" v-model="company.financialNotes" :disabled="onTheMarket"></b-form-textarea>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3">

        </b-col>
        <b-col md="6">
          <b-button class="margin-right"
            variant="success"
            type="button"
            @click="saveFinance()"
                    :disabled="onTheMarket"
            ><font-awesome-icon icon="save" />&nbsp;Save
          </b-button>
          <b-button
            variant="danger"
            type="button"
            @click="cancelFinance()"
                    :disabled="onTheMarket"
            ><font-awesome-icon icon="times" />&nbsp;Cancel Changes
          </b-button>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3">
        </b-col>
        <b-col md="6">
          <Feedback ref="saveFeedback"/>
        </b-col>
      </b-row>
    </div>

    <FinancialEditModal v-if="initialCompany" ref="editModal" :financial="selectedFinance" :currency="initialCompany.currency"/>
  </div>
</template>


<script>

import SubHeader from "@/components/shared/SubHeader.vue";
import FinancialEditModal from "@/components/company/financial/FinancialEditModal.vue";
import CompanyService from "@/services/Company.service";
import Feedback from "@/components/shared/Feedback.vue";

export default {
  components: {  SubHeader, FinancialEditModal, Feedback },
  props: {
    initialCompany: Object,
    companyFinancial: Array
  },
  data() {
    return {
      company: null,
      selectedFinance: null,
      onTheMarket: false,
      months: [ "January", "February", "March", "April", "May", "June",
           "July", "August", "September", "October", "November", "December" ],
      newFinance: { "id": 0, "companyId": 0, "year": null, "month": null, "isProjection": false, "isCvs": false,
        "grossProfit": null, "grossProfitPercent": null, "profitLossBeforeTax": null, "turnover": null, "ebit": null,
        "ebitda": null, "depreciation": null, "amortisation": null, "surplusAssets": null, "bankDeposits": null,
        "shareholdersFunds": null, "numberOfEmployees": null, "cashAtBank": null, "freeholdPropertyValue": null,
        "adjustedEbitda": null, "currentLiabilities": null, "netAssets": null }
    };
  },
  mounted() {
    if (this.initialCompany && this.company == null) {
      this.company = {...this.initialCompany};
    }
  },
  watch: {
    initialCompany: function() {
      this.company = { ...this.initialCompany };
      this.onTheMarket = this.initialCompany.companyLocked;
    },
  },
  methods: {
    editFinancial(selected) {
      this.selectedFinance = {...selected};
      this.$refs.editModal.showModal();

    },
    deleteFinancial(id) {

      var service = CompanyService;
      this.$bvModal.msgBoxConfirm('Are you sure you wish to delete this record?')
        .then(value => {
          if (value) {
            service.deleteCompanyFinances(id).then(() => {
              this.$parent.$parent.$parent.reloadCompanyFinances();
            });
          }
        })
    },
    addFinance() {
      this.selectedFinance = {...this.newFinance};
      this.selectedFinance.companyId = this.company.id;
      this.$refs.editModal.showModal();
    },
    cancelFinance() {
      this.company = {...this.initialCompany}
    },
    saveFinance() {
      CompanyService.saveCompanyFinanceNote({companyId: this.company.id, financeNote: this.company.financialNotes}).then(() => {
        this.$refs.saveFeedback.showSuccess("Save Successful");
      });
    },
  },
};
</script>

<style scoped>
  td {
    border: 1px solid #ddd;
    padding: 5px 5px;
  }

  .year-header {
    min-width: 120px;

  }

  .row-header {
    min-width: 240px;
  }

  .table-wrapper {
    overflow-x: scroll;
    margin-bottom: 20px;
  }

  .add-finance {
    margin-bottom: 20px;
  }



</style>
